import { useState } from 'react';
import { WrapperCard } from './WrapperCard';
import { getCurrency } from './utils/currency';
import { useEffect } from 'react';
import { apiSubscription } from '../../../api/apiSubscription.api';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';

export function HistoryPayment() {
  const axiosPrivate = useAxiosPrivate();
  const [historyList, setHistoryList] = useState([]);

  useEffect(() => {
    apiSubscription.history(axiosPrivate).then((res) =>
      setHistoryList(
        res.items.map((i) => ({
          _id: i._id,
          date: i.createdAt,
          price: i.orderId?.amount,
          currency: i.orderId?.currency,
          status: i.status,
        })),
      ),
    );
  }, []);

  return (
    <WrapperCard
      renderTop={() => <p className="uppercase">История платежей</p>}
      classNameChildren="!m-0 overflow-y-auto h-[260px]"
    >
      {historyList.length <= 0 && <p className="text-white opacity-60 text-center m-2">Вы ещё не совершали покупок</p>}
      {historyList.map((h, index) => (
        <HistoryCard
          className={index % 2 !== 1 && 'bg-[#043939]'}
          key={h._id}
          date={h.date}
          price={h.price}
          currency={h.currency}
          status={h.status}
        />
      ))}
    </WrapperCard>
  );
}

function configCard({ status, price, currency, date }) {
  console.log(price);

  const priceConfig = {
    success: () => (
      <p className="flex items-center ml-auto">
        {!isNaN(parseFloat(price)) ? `-${parseFloat(price).toFixed(2)}` : 'Бесплатно'}
        {getCurrency[currency] && getCurrency[currency]()}
      </p>
    ),
    reject: () => (
      <p className="flex items-center ml-auto">
        {parseFloat(price).toFixed(2)}
        {(getCurrency[currency] || getCurrency.default)()}
      </p>
    ),
    error: () => (
      <p className="flex items-center ml-auto">
        {parseFloat(price).toFixed(2)}
        {(getCurrency[currency] || getCurrency.default)()}
      </p>
    ),
  };

  const info = {
    success: () => (
      <p className="text-sm">
        {`Списано ${
          new Date(date)?.toLocaleDateString('ru-Ru', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
          }) || 'Дата не найдена'
        }`}
      </p>
    ),
    reject: () => (
      <p className="text-sm text-[#FF5334]">
        {`Не прошёл платёж  ${
          new Date(date)?.toLocaleDateString('ru-Ru', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
          }) || 'Дата не найдена'
        }`}
      </p>
    ),
    error: () => (
      <p className="text-sm text-[#FF5334]">
        {`Не прошёл платёж  ${
          new Date(date)?.toLocaleDateString('ru-Ru', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
          }) || 'Дата не найдена'
        }`}
      </p>
    ),
  };

  const icon = {
    success: () => <img src="/icons/premium-myata.svg" alt="myta" />,
    reject: () => <img src="/icons/premium-myata-dark.svg" alt="myta" />,
    error: () => <img src="/icons/premium-myata-dark.svg" alt="myta" />,
  };

  return {
    Price: priceConfig[status] || priceConfig.success,
    Info: info[status] || info.success,
    Icon: icon[status] || icon.success,
  };
}

function HistoryCard({ date, price, currency, status, className = '' }) {
  const { Price, Info, Icon } = configCard({ price, currency, status, date });

  return (
    <div className={`flex items-center justify-between gap-2 text-white py-2 px-4 ${className}`}>
      <Icon />
      <div>
        <p className="text-xs font-semibold opacity-70 mb-[2px]">Myta Premium</p>
        <Info />
      </div>
      <Price />
    </div>
  );
}
